<template>
  <img
    src="/aggremate-mark.svg"
    height="40"
    width="40"
    alt="Aggremate"
    style="object-fit: contain;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
